import React, { useContext } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import style from './index.css';
import PropTypes from 'prop-types';
import ShareContext from '../../store';
import Atlas from './Atlas';
import Play from './Play';

const Detail = ({ isYesterday, category, list }) => {
    // 获取context中的文字颜色
    const textcolor = useContext(ShareContext).color;

    // 判断此时应该选用哪种颜色进行渲染
    const judgenowcolor = () => {
        if (isYesterday) {
            return textcolor.yesterdayDay;
        } else {
            return textcolor.day;
        }
    };

    // 处理后端数据，将em标签后加入行内样式
    const handlecolor = (htmlstr) => {
        return htmlstr.replaceAll('<em>', `<em style='color: ${judgenowcolor()}; font-style: normal; font-weight: bold;'>`);
    };

    return list ? (
        <div className={style.endnews}>
            <div className={style.topic}>
                <span style={{ backgroundColor: judgenowcolor() }}> {category} </span>
            </div>
            {list.map((item) => (
                <div key={item.title}>
                    <div className={style.newsinfo} dangerouslySetInnerHTML={{ __html: handlecolor(item.title) }} />
                    {item?.imageInfoList?.length > 0 && <Atlas content={item} isLoadGallery={true} />}
                    {item?.videoInfo && <Play videoInfo={item.videoInfo} />}
                </div>
            ))}
        </div>
    ) : null;
};

Detail.propTypes = {
    isYesterday: PropTypes.bool,
    category: PropTypes.string,
    list: PropTypes.array,
};

export default errorBoundary(Detail);
